"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SimpleFadeIn = void 0;

var _react = _interopRequireDefault(require("react"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

var SimpleFadeIn = function SimpleFadeIn(_ref) {
  var children = _ref.children,
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 0 : _ref$delay,
      _ref$transition = _ref.transition,
      transition = _ref$transition === void 0 ? 1.4 : _ref$transition;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: _styleModule.default.animated,
    style: {
      opacity: delay > 0 ? 0 : 1,
      animationIterationCount: 1,
      animationDuration: transition + 's',
      animationDelay: delay + 'ms'
    },
    children: children
  });
};

exports.SimpleFadeIn = SimpleFadeIn;
var _default = SimpleFadeIn;
exports.default = _default;